export const UTR_REGEX = /^\d{12}$/;

export function isValidUtr(value) {
  return UTR_REGEX.test(String(value ?? "").trim());
}
